import styles from './Tags.module.css';

export type TagProps = {
  value?: string;
  theme?: string;
};

interface TagsProps {
  tags: TagProps[];
}

export function Tags({ tags = [] }: TagsProps) {
  return (
    <div className={styles.tags}>
      {tags.map((tag) => (
        <span
          className={styles.tagsItem}
          key={`tag-${tag.theme}`}
          data-theme={tag.theme}
          data-testid="tagItem"
        >
          {tag.value || tag.theme}
        </span>
      ))}
    </div>
  );
}
